// extracted by mini-css-extract-plugin
module.exports = {"content":"BookHasNotReviews__content","image":"BookHasNotReviews__image"};